import storage from "redux-persist/lib/storage";
import { persistCombineReducers } from "redux-persist";
import { encryptTransform } from "redux-persist-transform-encrypt";
import { connectRouter } from "connected-react-router";
import app from "./app";
import locations from "./locations";
import user from "./user";
import catalogue from "./catalogue";
import myProperties from "./my-properties";
import tasks from "./tasks";
import item from "./item";
import jobs from "./jobs";
import market from "./market";
import abn from "./abn";
import ads from "./ads";
import quote from "./quote";
import analytics from "./analytics";
import agentAnalytics from "./agent-analytics";
import agentRecommendation from "./agent-recommendations";
import connectedCustomers from "./connectedCustomers";

const encryption = encryptTransform({ secretKey: process.env.REDUX_PERSIST_SECRET_KEY });

const config = {
  whitelist: ["user"],
  key: "primary",
  storage,
  transforms: [encryption],
};

export default (history) => persistCombineReducers(config, {
  ads,
  app,
  locations,
  router: connectRouter(history),
  user,
  catalogue,
  item,
  tasks,
  myProperties,
  jobs,
  market,
  quote,
  abn,
  analytics,
  agentAnalytics,
  agentRecommendation,
  connectedCustomers,
});
